<template lang="html">
  <modal ref="modal" size="fluid" :title="team ? team.name : ''">
    <draft-roster v-if="roster" :roster="roster" />
  </modal>
</template>

<script>
import DraftRoster from './DraftRoster';

export default {
  components: {
    DraftRoster,
  },

  props: {
    team: Object,
  },

  computed: {
    roster() {
      return this.team ? this.$store.getters['draft/roster'](this.team.id) : null;
    },
  },

  methods: {
    open() {
      this.$refs.modal.open();
    },

    close() {
      this.$refs.modal.close();
    },
  },
};
</script>
